<template>
  <el-drawer title="编辑" :visible.sync="drawer" size="50%" :before-close="handleClose">
    <div class="m-tabs-content">
      <el-form :model="product" :rules="rules" ref="upForm" label-width="80px">
        <el-form-item label="产品名称" prop="title">
          <el-input v-model="product.title" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="产品类目" prop="type">
          <el-select v-model="product.type" placeholder="请选择" size="mini">
            <el-option label="公司注册" value="公司注册"></el-option>
            <el-option label="代理记账" value="代理记账"></el-option>
            <el-option label="增值服务" value="增值服务"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品规格">
          <el-tag
            :key="tagIndex"
            v-for="(tag, tagIndex) in specifications"
            closable
            :disable-transitions="false"
            @close="handleTagClose(tag)">
            {{tag.specification_name}}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="tagInputVisible"
            v-model="tagInputValue"
            ref="updateTagInput"
            size="mini"
            @keyup.enter.native="handleTagInputConfirm"
            @blur="handleTagInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" size="mini" @click="showTagInput">添加规格</el-button>
        </el-form-item>
        <el-form-item label="封面图片">
          <el-input v-model="product.image" placeholder="选择图片" prefix-icon="el-icon-picture-outline" size="mini" disabled>
            <el-button slot="append" type="primary" icon="el-icon-folder-opened" size="mini" @click="triggerFileInput">
              浏览
              <input type="file" ref="productFileInput" id="productFileInput" style="display: none" @change="handleFileChange" />
            </el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="产品详情" class="ueditor">
          <vue-ueditor-wrap
            v-model="product.description"
            :config="myConfig"
          ></vue-ueditor-wrap>
        </el-form-item>
        <el-form-item label="上架">
          <el-radio-group v-model="product.on_sale" size="mini">
            <el-radio label="是" border>是</el-radio>
            <el-radio label="否" border>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-divider content-position="left">SKU列表</el-divider>
        <el-row>
          <el-col :span="24" class="tr">
            <el-button type="primary" size="mini" @click="addSku">添加SKU</el-button>
          </el-col>
        </el-row>
        <div class="mb-10" v-for="(item, index) in product.skus" :key="index">
          <el-form-item label="sku 描述">
            <el-input v-model="item.sku_description" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="单价" :prop="'skus.' + index + '.sku_price'">
            <el-input v-model.number="item.sku_price" size="mini"></el-input>
          </el-form-item>
          <div v-for="(spec, specIndex) in specifications" :key="specIndex">
            <el-form-item :label="spec.specification_name" :prop="`skus.${index}.${spec.specification_name}`">
              <el-input v-model="item[spec.specification_name]" size="mini"></el-input>
            </el-form-item>
          </div>
          <el-row>
            <el-col :span="24" class="tr">
              <el-button type="warning" size="mini" icon="el-icon-delete" @click="delSku(index)">删除</el-button>
            </el-col>
          </el-row>
        </div>
        <el-divider />
        <el-row>
          <el-col :span="24" class="tr sub">
            <el-button type="primary" size="mini" @click="handelSubForm('upForm')">提交</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap"
export default {
  name: 'ProductEditDrawer',
  components: {
    VueUeditorWrap
  },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    productId: {
      type: Number
    }
  },
  watch: {
    productId (newId) {
      if (newId) this.getProduct()
    },
    'product.skus': {
      handler (newVal) {
        this.updateSkuRules(newVal)
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      product: {
        skus: []
      },
      productFile: null,
      rules: {
        title: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '请选择品类', trigger: 'blur' },
        ]
      },
      specifications: [],
      tagInputVisible: false,
      tagInputValue: '',
      myConfig: {
        autoHeightEnabled: false,
        initialFrameHeight: 250,
        initialFrameWidth: "100%",
        serverUrl: this.$store.state.serverUrl,
        zIndex: 9999,
        toolbars: [
          [
            "bold",
            "italic",
            "underline",
            "fontborder",
            "strikethrough",
            "superscript",
            "subscript",
            "removeformat",
            "formatmatch",
            "autotypeset",
            "blockquote",
            "pasteplain",
            "|",
            "forecolor",
            "backcolor",
            "|",
            "rowspacingtop",
            "rowspacingbottom",
            "lineheight",
            "paragraph",
            "fontfamily",
            "fontsize",
            "justifyleft",
            "justifycenter",
            "justifyright",
            "justifyjustify",
            "indent",
            "|",
            "imageleft",
            "imageright",
            "imagecenter",
            "simpleupload",
            "preview",
          ],
        ],
      }
    }
  },
  methods: {
    getProduct () {
      this.$axios.get('/api/admin/qyh_products/' + this.productId, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.product = data.data.product
            this.specifications = data.data.specifications
            this.initializeSkus()
          }
        })
    },
    initializeSkus () {
      this.product.skus.forEach(sku => {
        this.specifications.forEach(spec => {
          if (!sku.hasOwnProperty(spec.specification_name)) {
            let specificationValue = sku.sku_specification_values.find(value => value.specification_id === spec.id)
            this.$set(sku, spec.specification_name, specificationValue.specification_value)
          }
        })
      })
      console.log(this.product)
    },
    updateSkuRules (skus) {
      const newSkuRules = {};
      skus.forEach((sku, index) => {
        newSkuRules[`skus.${index}.sku_title`] = [
          { required: true, message: '请输入 SKU 名称', trigger: 'blur' }
        ];
        newSkuRules[`skus.${index}.sku_price`] = [
          { required: true, message: '请输入单价', trigger: 'blur' },
          { type: 'number', message: '单价必须是数字', trigger: 'blur' }
        ];
        // 遍历 specifications 动态添加规则
        this.specifications.forEach((spec) => {
          newSkuRules[`skus.${index}.${spec.specification_name}`] = [
            { required: true, message: `请输入 ${spec.specification_name}`, trigger: 'blur' }
          ];
        });
      })
      this.rules = {
        title: this.rules.title,
        type: this.rules.type,
        ...newSkuRules
      };
    },
    clearEditDrawerData () {
      this.product = {skus: []}
      this.specifications = []
      this.tagInputVisible = false
      this.tagInputValue = ''
    },
    handleClose () {
      this.clearEditDrawerData()
      this.$emit('handleClose', false)
    },
    handleTagClose (tag) {
      this.specifications.splice(this.specifications.indexOf(tag), 1);
    },
    handleTagInputConfirm () {
      let inputValue = this.tagInputValue
      if (inputValue) {
        this.specifications.push({ product_id: this.productId, specification_name: inputValue })
      }
      this.tagInputVisible = false
      this.tagInputValue = ''
    },
    showTagInput () {
      this.tagInputVisible = true
      this.$nextTick(_ => {
        this.$refs.updateTagInput.$refs.input.focus();
      })
    },
    triggerFileInput () {
      this.$refs.productFileInput.click()
    },
    handleFileChange (event) {
      const file = event.target.files[0]
      if (file) {
        if (!file.type.startsWith('image/')) {
          this.$message.error('只能选择图片')
          return
        }
        this.product.image = file.name
        this.product.file = file
      }
    },
    addSku () {
      this.product.skus.push({ product_id: this.productId, sku_description: '', sku_price: 0 })
    },
    delSku (index) {
      this.product.skus.splice(index, 1)
      // this.updateSkuRules(this.addForm.skus)
    },
    handelSubForm (formName) {
      if (this.specifications.length === 0) {
        return this.$message.error('请添加产品规格')
      }

      if (this.product.skus.length === 0) {
        return this.$message.error('请添加产品sku')
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let formData = new FormData()
          for (let key in this.product) {
            if (key === 'skus') {
              this.product[key].forEach((sku, index) => {
                for (let skuKey in sku) {
                  formData.append(`skus[${index}][${skuKey}]`, sku[skuKey]);
                }
              })
            } else {
              formData.append(key, this.product[key])
            }
          }
          this.specifications.forEach((specification, index) => {
            for (let spec in specification) {
              formData.append(`specifications[${index}][${spec}]`, specification[spec])
            }
          })

          this.$axios.post('/api/admin/qyh_product/up', formData, { loadingClose: true })
            .then((res) => {
              const { data } = res
              if (data.code === 0) {
                this.$message.success(data.msg)
                this.handleClose()
                this.$emit('refreshData')
              }
            })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.el-drawer__wrapper >>> .el-drawer__body {
  overflow-y: auto
}
.el-form-item {
  margin-bottom: .2rem;
}
.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner, .el-select {
  width 100%;
}
.el-form-item__content .el-input-group {
  vertical-align: middle;
}
.tr {
  text-align: right;
}
.mb-10 {
  margin-bottom: .2rem;
}
.el-input-group__append button.el-button, .el-input-group__append div.el-select .el-input__inner, .el-input-group__append div.el-select:hover .el-input__inner, .el-input-group__prepend button.el-button, .el-input-group__prepend div.el-select .el-input__inner, .el-input-group__prepend div.el-select:hover .el-input__inner {
  color: #FFF;
  background-color: #409EFF;
  border: 1px solid #409eff;
  border-bottom: 0;
}
.sub {
  padding-bottom: .2rem;
}
.ueditor >>> .el-form-item__content {
  line-height: normal;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.input-new-tag {
  width: 90px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/pages/all_products/common/ProductEditDrawer.vue